import { Node, mergeAttributes } from '@tiptap/core'

/**
 * Node customizado para preservar imagens com todos os atributos
 * Mantém src, alt, title, width, height, style, class, etc.
 */
export const CustomImgNode = Node.create({
    name: 'customImg',
    group: 'inline',
    inline: true,
    atom: true,

    addAttributes() {
        return {
            src: {
                default: null,
                parseHTML: element => element.getAttribute('src'),
                renderHTML: attributes => attributes.src ? { src: attributes.src } : {},
            },
            alt: {
                default: null,
                parseHTML: element => element.getAttribute('alt'),
                renderHTML: attributes => attributes.alt ? { alt: attributes.alt } : {},
            },
            title: {
                default: null,
                parseHTML: element => element.getAttribute('title'),
                renderHTML: attributes => attributes.title ? { title: attributes.title } : {},
            },
            width: {
                default: null,
                parseHTML: element => element.getAttribute('width'),
                renderHTML: attributes => attributes.width ? { width: attributes.width } : {},
            },
            height: {
                default: null,
                parseHTML: element => element.getAttribute('height'),
                renderHTML: attributes => attributes.height ? { height: attributes.height } : {},
            },
            style: {
                default: null,
                parseHTML: element => element.getAttribute('style'),
                renderHTML: attributes => attributes.style ? { style: attributes.style } : {},
            },
            class: {
                default: null,
                parseHTML: element => element.getAttribute('class'),
                renderHTML: attributes => attributes.class ? { class: attributes.class } : {},
            },
        }
    },

    parseHTML() {
        return [{
            tag: 'img',
            getAttrs: element => ({
                src: element.getAttribute('src'),
                alt: element.getAttribute('alt'),
                title: element.getAttribute('title'),
                width: element.getAttribute('width'),
                height: element.getAttribute('height'),
                style: element.getAttribute('style'),
                class: element.getAttribute('class'),
            }),
        }];
    },

    renderHTML({ node, HTMLAttributes }) {
        const attrs = {};
        Object.keys(node.attrs).forEach(key => {
            if (node.attrs[key] !== null && node.attrs[key] !== undefined) {
                attrs[key] = node.attrs[key];
            }
        });
        return ['img', mergeAttributes(this.options.HTMLAttributes, HTMLAttributes, attrs)];
    },
});